<template>
  <button
    class="up-btn"
    v-bind="$attrs"
  >
    <slot />
  </button>
</template>
<script>
export default {
  name: 'upButton',
  inheritAttrs: false,
};
</script>
<style lang="scss" scoped>
.up-btn {
  width: 100%;
  text-align: center;
  background: #FFFEFB;
  border: 2px solid #2D3038;
  color: #2D3038;
}
</style>
